import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NavigationInfoState {
    currentRoute: string | null;
    previousRoute: string | null;
}

const initialState: NavigationInfoState = {
    currentRoute: sessionStorage.getItem('currentRoute') || null,
    previousRoute: sessionStorage.getItem('previousRoute') || null,
};

export const navigationInfoSlice = createSlice({
    name: 'navigationInfo',
    initialState,
    reducers: {
        setRouteHistory: (state, action: PayloadAction<{ current: string; previous: string | null }>) => {
            state.currentRoute = action.payload.current;
            state.previousRoute = action.payload.previous;
        }
    }
});

export const { setRouteHistory } = navigationInfoSlice.actions;

export default navigationInfoSlice.reducer;
